<div id="parent" style="width: 100%; height: auto;">

    <div id="suspects-map-headers-main">
        <div id="suspects-map-headers">
            <div class="suspects-map-header1">
                {{header1_line1}}<br/>
                {{header1_line2}}<br/>            
            </div>
            <div class="suspects-map-header2">{{header2}}</div>
            <div class="suspects-map-header3">
                {{header3_line1}}<br/>
                {{header3_line2}}
            </div>
        </div>
        <div id="suspects-map-export">
            <dx-button icon="exportxlsx" class="ap-blue-btn"
                (onClick)="exportExcel($event)" text="Export to Excel">
            </dx-button>
        </div>
    </div>
    <div class="suspects-map-container">                      
        <div id="suspects-map-viewport" class="suspects-map-viewport" [class.info-text]="showInfoText"></div>
        <div style="margin-right: 15px"></div>
        <div id="suspects-map-legend" class="suspects-map-legend" [hidden]="hideLegend">
            <b>Industry Segment</b>
            <hr />
        </div>
    </div>

    <div id="suspects-map-grid">
        <h6 class="ap-green">{{header4}}</h6>  
        <div style="margin-top: 20px;"></div>  
        <dx-pivot-grid #SuspectsMapCustNearPlantGrid id="CustomersNearPlantGrid" 
            [elementAttr]="{class: 'suspects-map-grid-size'}"
            [allowSortingBySummary]="true" [allowFiltering]="false" [dataFieldArea]="'column'"
            [showBorders]="true" [showColumnGrandTotals]="false" [showRowGrandTotals]="true" [showRowTotals]="false"
            [showColumnTotals]="false" [dataSource]="pivotGrid_CustomersNearPlant_Datasource">
            <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
            <dxo-field-panel
                [showDataFields]="false"
                [showRowFields]="true"
                [showColumnFields]="false"
                [showFilterFields]="false"
                [allowFieldDragging]="false"
                [visible]="true">
            </dxo-field-panel>
            <dxo-scrolling mode="virtual"></dxo-scrolling> 
            <dxo-load-panel [enabled]="false"></dxo-load-panel>                   
        </dx-pivot-grid>
    </div>

</div>